<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="fin-code-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="fin-code-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="fin-code-code" class="form-label">Code</label>
              <input type="text" class="form-control" id="fin-code-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="fin-code-cat" class="form-label">Category</label>
              <select class="form-control" id="fin-code-rep" v-model="entity.category">
                <option value=""></option>
                <option value="NOMINAL">Nominal</option>
                <option value="SUBTOTAL">Sub total</option>
                <option value="COST_ELEMENT">Cost element</option>
                <option value="CHARGE_ELEMENT">Charge element</option>
              </select>
            </div>
            <div class="form-group">
              <label for="fin-code-analysis" class="form-label">Reporting code</label>
              <select class="form-control" id="fin-code-rep" v-model="entity.reportingCode">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('FINANCIAL_REPORTING_CODE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="fin-code-analysis" class="form-label">Analysis code</label>
              <select class="form-control" id="fin-code-analysis" v-model="entity.analysisCode">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('FINANCIAL_ANALYSIS_CODE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="fin-code-exA" class="form-label">Export part A</label>
              <input type="text" class="form-control" id="fin-code-exA" v-model="entity.exportPartA"/>
            </div>
            <div class="form-group">
              <label for="fin-code-exB" class="form-label">Export part B</label>
              <input type="text" class="form-control" id="fin-code-exB" v-model="entity.exportPartB"/>
            </div>
            <div class="form-group">
              <label for="fin-code-exC" class="form-label">Export part C</label>
              <input type="text" class="form-control" id="fin-code-exC" v-model="entity.exportPartC"/>
            </div>
            <div class="form-group">
              <label for="location-comments" class="form-label">Comments</label>
              <textarea class="form-control" rows="5" id="location-comments" v-model="entity.notes"></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'FinancialCode',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        transformForUpdate: {
          category: this.toMinus,
          reportingCode: this.toMinus,
          analysisCode: this.toMinus
        },
        shouldUpdateCache: true,
        cachePropertyName: 'financialCodes',
        newEntityScreen: 'Admin - Financial Codes',
        editEntityScreen: 'Admin - Edit/View Financial Code',
        tab: 'main',
        boxes: [
          {
            prop: 'analysisCode',
            id: 'id'
          },
          {
            prop: 'reportingCode',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          code: '',
          name: '',
          category: '',
          parent: '',
          exportPartA: '',
          exportPartB: '',
          exportPartC: '',
          analysisCode: '',
          reportingCode: '',
          notes: ''
        },
        entityName: 'financial-code'
      }
    },
    computed: {
      isValid () {
        return this.entity.name !== ''
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          code: '',
          name: '',
          category: '',
          parent: '',
          exportPartA: '',
          exportPartB: '',
          exportPartC: '',
          analysisCode: '',
          reportingCode: '',
          notes: ''
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/FinancialCode/FinancialCode.vue